import React, { useRef, useState, useEffect, useCallback, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';

import {
	makeStyles,
	RootRef,
	Grid
} from '@material-ui/core';

//import Constants from "../utils/Constants";
import { useScrollTo, usePrevious } from "../utils/CustomHooks";

const styles = makeStyles(theme => ({
	root: {
		overflowY: "auto",
		overflowX: "hidden",

		"&::-webkit-scrollbar": {
			width: theme.spacing(1),
			backgroundColor: ""
		},

		"&::-webkit-scrollbar-thumb": {
			borderRadius: 8,
			backgroundColor: "#D9DCDD"
		}
	},

	item: {
		width: "100%",
		display: "flex"
	},

	child: {
		width: "100%"
	}
}));

function ScrollableArea(props) {
	const rootDivRef = useRef();
	const scrollToHook = useScrollTo();
	const [offsetTop, setOffsetTop] = useState(-1);

	let {scrollTo} = props;

	const getHeight = useCallback(() => {
		if (props.fitToParent && rootDivRef.current) {
			return rootDivRef.current.parentElement.offsetHeight;
		} else if (props.fitToWindowHeight) {
			return window.innerHeight;
		} else {
			return document.documentElement.clientHeight;
		}
	}, [props.fitToParent, props.fitToWindowHeight]);

	const [windowHeight, setWindowHeight] = useState(getHeight());

	useEffect(() => {
		function onResize() {
			setWindowHeight(getHeight());
		}
		window.addEventListener("resize", onResize);
	}, [props.fitToWindowHeight, getHeight]);

	let prevScrollTo = usePrevious(props.scrollTo);
	useEffect(() => {
		if (rootDivRef.current && prevScrollTo !== scrollTo) {
			scrollToHook(0, scrollTo, rootDivRef.current);
		}
	}, [scrollTo, prevScrollTo, scrollToHook]);

	useEffect(() => {
		if (rootDivRef.current/* && props.fitToParent*/) {
			setWindowHeight(getHeight());
		}
	}, [/*props.fitToParent,*/ getHeight]);

	// keep track of offsetTop as when backing up on mobile, rendering / offsetTop isn't correct at first
	useLayoutEffect(() => {
		setOffsetTop(rootDivRef.current && rootDivRef.current.offsetTop);
	}, [offsetTop, setOffsetTop]);

	let classes = styles(),
		{children, className, heightReduction, fitToWindowHeight, scrollGridClassName, scrollGridItemClassName} = props,
		height = windowHeight - heightReduction -
			(fitToWindowHeight && offsetTop > -1 ? offsetTop : 0),
		newChildren = React.Children.map(children, child => React.cloneElement(child, {className: `${child.props.className} ${classes.child}`}));

	return (
		<RootRef rootRef={rootDivRef}>
			<Grid
				container
				style={{height: height}}
				className={`${classes.root} ${className} ${scrollGridClassName}`}>
				<Grid item className={`${classes.item} ${scrollGridItemClassName}`}>
					{newChildren}
				</Grid>
			</Grid>
		</RootRef>
	);
}

ScrollableArea.defaultProps = {
	scrollTo: 0,
	heightReduction: 0,
	fitToParent: false,
	fitToWindowHeight: true
};

ScrollableArea.propTypes = {
	className: PropTypes.string,
	children: PropTypes.any,
	heightReduction: PropTypes.number,
	fitToWindowHeight: PropTypes.bool,
	scrollTo: PropTypes.number,
	fitToParent: PropTypes.bool,
	scrollGridClassName: PropTypes.string,
	scrollGridItemClassName: PropTypes.string
};

export default ScrollableArea;